import { SavedReportsTranslation } from '../constants';
import { GenericSavedReport, SavedReportValidation } from '../types-store';
import { OnUpdateSavedReport, UpdateSavedReportHandler, ValidateSavedReportHandler } from '../types';

interface ProcessSavedReportPayload<SavedReport extends GenericSavedReport> {
  accessType: number;
  currentSavedReportId: number;
  currentSavedReport: SavedReport;
  allSavedReportIs: number[];
  validation: SavedReportValidation<SavedReport>;
  translation: SavedReportsTranslation;
  validateSavedReport: ValidateSavedReportHandler<SavedReport>;
  updateSavedReport: UpdateSavedReportHandler<SavedReport>;
  updateValidation: (validation: SavedReportValidation<SavedReport>) => void;
  loadEvaluation: (accessType: number, favouriteId: number, onUpdateSavedReport: OnUpdateSavedReport<SavedReport>) => void;
  displayError: (errorMessage: string) => void;
  onClose: () => void;
}

export const processSavedReport: <SavedReport extends GenericSavedReport>(
  payload: ProcessSavedReportPayload<SavedReport>
) => (() => void) = <SavedReport extends GenericSavedReport>({
  accessType, currentSavedReportId, currentSavedReport, allSavedReportIs,
  validateSavedReport, updateSavedReport, updateValidation, loadEvaluation, displayError, onClose,
  validation, translation
}) => () => {

  const savedReportValidation =
    validateSavedReport(currentSavedReport, currentSavedReportId, allSavedReportIs, translation);

  if (Object.keys(savedReportValidation).length > 0) {

    updateValidation({
      ...validation,
      ...savedReportValidation
    });
    displayError(translation.fields_are_filled_out_incorrectly);

    return;
  }

  const onUpdateSavedReport: OnUpdateSavedReport<SavedReport> = (savedReport, currentValidation) => {
    updateSavedReport(currentSavedReportId, savedReport, currentValidation);
    onClose();
  };

  if (currentSavedReportId !== currentSavedReport.code.value) {
    loadEvaluation(accessType, currentSavedReport.code?.value, onUpdateSavedReport);
  } else {
    onUpdateSavedReport(currentSavedReport, validation);
  }
};
